import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getComponentClasses } from '../../utils/app';

export interface UserProps {
    name?: string;
    profileUrl?: string;
    isActive?: boolean;
}

export interface Props {
    user: UserProps;
    variations?: string[];
    isLinked?: boolean;
    isTruncated?: boolean;
    limit?: number;
}

export const DisplayName = ({
    user = {
        isActive: false,
    },
    variations = [],
    isLinked = true,
    isTruncated = false,
    limit = 20,
}: Props) => {
    if (isLinked && user.profileUrl) {
        variations.push('link');
    }

    if (isTruncated) {
        variations.push('truncate');
    }

    const classes = getComponentClasses('display-name', variations);

    const truncate = (name: string, limit: number) => name.split('').slice(0, limit).join('');

    const displayName =
        (user.isActive && <FormattedMessage id="own_username" />) ||
        (isTruncated && user.name && truncate(user.name, limit)) ||
        user.name;

    if (isLinked && user.profileUrl) {
        return (
            <a
                className={classes}
                href={user.profileUrl}
                data-testid={`display-name-${displayName}`}
            >
                {displayName}
            </a>
        );
    } else {
        return (
            <span className={classes} data-testid={`display-name-${displayName}`}>
                {displayName}
            </span>
        );
    }
};

export default DisplayName;
